export const useApi = () => useNuxtApp().$apiGenManager;
